import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { enumTiposGestion } from "../commons/enumTipoGestion";


// Para facilitar el manejo de estados de obra
// Esto ya agrega la opcion de editar en base al estado
// Y permite obtener el nombre de gestion a partir del id de gestion obra.

const useGestionObra = (
  lastTipoGestionObra,
  lastEstadoObra,
  informadoSRT,
  habilitarEdicionObra,
) => {
  const tiposDeGestion = useSelector((state) => state.obra.getTiposAvisoObra.data);
  const habilitadoGuardadoObrasConIntercambiosPendientes = useSelector((state) => state.obra.habilitadoGuardadoObrasConIntercambiosPendientes.data);

  const tiposDeGestionMemorizados = useMemo(() => {

    let tiposDeGestionObra = [];

    if (habilitarEdicionObra === "1" && !informadoSRT && lastEstadoObra === "En Obra")
      tiposDeGestionObra.push({ nombre: enumTiposGestion.edicion, id: enumTiposGestion.edicion })

    if (habilitadoGuardadoObrasConIntercambiosPendientes === "1" || informadoSRT)
      tiposDeGestionObra.push(...tiposDeGestion)

    return tiposDeGestionObra

  }, [tiposDeGestion, lastEstadoObra, informadoSRT, habilitarEdicionObra, habilitadoGuardadoObrasConIntercambiosPendientes]);

  const nombreTipoGestion = useCallback((idTipoGestionObra, puedeSerEdicion = false) => {
    const tipoDeGestionSeleccionada = tiposDeGestionMemorizados.find((t) => t.id == idTipoGestionObra)?.nombre;
    if (tipoDeGestionSeleccionada === enumTiposGestion.edicion && !puedeSerEdicion) {
      return lastTipoGestionObra;
    }
    return tipoDeGestionSeleccionada
  }, [lastTipoGestionObra, tiposDeGestionMemorizados])

  return [nombreTipoGestion, tiposDeGestionMemorizados];
}

export default useGestionObra;